import getRootDomain from './getRootDomain';
import Cookies from 'js-cookie';

const validateNewDtcVisitor = (
  brandWebsite: string | undefined,
  shopifyStoreName: string | undefined
) => {
  if (!brandWebsite) return null;
  if (getRootDomain(brandWebsite) !== getRootDomain(window.location.href))
    return null;
  if (!shopifyStoreName) return null;
  return Cookies.get('_shopify_y') ? false : true;
};

export default validateNewDtcVisitor;
